import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';
import CameraIcon from '@quintoandar/cozy-icons/Camera';
import Box from '@quintoandar/cozy-core/Box';
import FeedbackBlock from '@quintoandar/cozy-core/FeedbackBlock';
import { LoadingPage } from 'components/LoadingPage';
import RetryFeedback from 'components/RetryFeedback';

import Timeline from 'components/Timeline';
import { fetchNotStartedPhotoSessionsAction } from './actions';
import {
  makeSelectToReschedulePhotoSessions,
  makeSelectHasFetchedNotStartedPhotoSessions,
  makeSelectShowNotStartedListError,
} from './selectors';
import { buildPhotoSessionItems } from './photoSessionItemsBuilder';
import messages from './messages';

export const ReschedulePhotoSessions = ({
  photoSessions,
  fetchNotStartedPhotoSessions,
  intl,
  hasFetchedNotStartedPhotoSessions,
  showListError,
}) => {
  /* istanbul ignore next */
  useEffect(() => {
    // NotStartedPhotoSessions already loads this list; avoid a second request
    // when the Reagendar tab mounts after that fetch has completed.
    if (!hasFetchedNotStartedPhotoSessions) {
      fetchNotStartedPhotoSessions();
    }
  }, [hasFetchedNotStartedPhotoSessions, fetchNotStartedPhotoSessions]);
  if (!hasFetchedNotStartedPhotoSessions) {
    return <LoadingPage />;
  }

  if (photoSessions.length === 0) {
    if (showListError) {
      return (
        <RetryFeedback
          title={messages.notStartedPhotoSessionsError}
          subtitle={messages.listErrorSubtitle}
          onRetry={fetchNotStartedPhotoSessions}
        />
      );
    }

    return (
      <Box mt={4}>
        <FeedbackBlock
          kind="empty-state"
          icon={CameraIcon}
          subtitle={messages.reschedulePhotoSessionsEmptyStateSubTitle}
          title={messages.reschedulePhotoSessionsEmptyStateTitle}
          showButton={false}
        />
      </Box>
    );
  }

  const reschedulePhotoSessions = buildPhotoSessionItems({ photoSessions, intl });

  return <Timeline scheduledItems={reschedulePhotoSessions} />;
};

const mapStateToProps = createStructuredSelector({
  photoSessions: makeSelectToReschedulePhotoSessions(),
  hasFetchedNotStartedPhotoSessions: makeSelectHasFetchedNotStartedPhotoSessions(),
  showListError: makeSelectShowNotStartedListError(),
});

export const mapDispatchToProps = (dispatch) => ({
  fetchNotStartedPhotoSessions: () => dispatch(fetchNotStartedPhotoSessionsAction()),
});

ReschedulePhotoSessions.propTypes = {
  photoSessions: PropTypes.array,
  fetchNotStartedPhotoSessions: PropTypes.func.isRequired,
  intl: PropTypes.object,
  hasFetchedNotStartedPhotoSessions: PropTypes.bool,
  showListError: PropTypes.bool,
};

ReschedulePhotoSessions.defaultProps = {
  photoSessions: [],
};

export default compose(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps)
)(ReschedulePhotoSessions);
